import * as Blockly from 'blockly/core';
import indicatorContentFile from './indicator_content'
import info_image from "@/assets/info_dark_24dp.svg"
import { ManageDialogsService } from '@/services/manageDialogs.service';

const createInfoButton = function (input, block) {
    block.indicatorInfo = indicatorInfo;
    input.appendField(new Blockly.FieldImage(info_image, 24, 24, "Find out more", block.indicatorInfo), 'indicatorInfo')
}

function indicatorInfo() {
    let sourceBlock = this.getSourceBlock();
    let indicatorValue = sourceBlock.getFieldValue("indicator_selection");
    let indicatorContent = indicatorContentFile[indicatorValue];
    ManageDialogsService.indicatorInfoDialog(indicatorContent);
}

export default createInfoButton